
import { Eye, Pencil } from "lucide-react";
import { cn } from "@/lib/utils";
import { useEditMode } from "../hooks/useEditMode";

/**
 * Edit mode toggle that shows current mode state and allows switching.
 * Clicking toggles between View Only and Editing modes.
 */
export function EditModeToggle() {
  const { isReadonly, toggleEditMode, canEdit } = useEditMode();

  if (!canEdit) return null;

  return (
    <button
      onClick={toggleEditMode}
      className={cn(
        "flex items-center gap-1.5 px-2 md:px-2.5 py-2 rounded-lg text-xs font-medium",
        "backdrop-blur-sm border transition-colors cursor-pointer min-h-[40px]",
        "bg-sands-50/90 border-sands-200 text-sands-500 hover:bg-sands-100/90 hover:text-sands-600",
      )}
      title={isReadonly ? "Enter Edit Mode" : "Exit Edit Mode"}
    >
      {isReadonly ? (
        <>
          <Eye className="w-3.5 h-3.5 shrink-0" />
          <span className="hidden sm:inline">View Only</span>
        </>
      ) : (
        <>
          <Pencil className="w-3.5 h-3.5 shrink-0" />
          <span className="hidden sm:inline">Editing</span>
        </>
      )}
    </button>
  );
}
